import { Button, Typography } from "@suraasa/placebo-ui"
import SuraasaPlusOverlay from "assets/masterclass/suraasa-plus-overlay.webp"
import SuraasaPlusLogo from "features/SuraasaPlus/components/SuraasaPlusLogo"
import { useSuraasaPlusContext } from "features/SuraasaPlus/context"
import { Lock } from "iconoir-react"

import DEFAULT_MASTERCLASS_IMAGE from "@/../assets/Placeholder/default-masterclass-thumbnail.svg"

const TrySuraasaPlusScreen = ({ thumbnail }: { thumbnail: string }) => {
  const { initiateSuraasaPlusPurchaseFlow } = useSuraasaPlusContext()

  return (
    <div className="relative">
      <div
        className="absolute inset-0 z-10 rounded-lg bg-[rgba(0,0,0,0.80)] bg-cover bg-center p-4"
        style={{
          backgroundImage: `url(${SuraasaPlusOverlay})`,
        }}
      >
        <div className="hidden flex-wrap items-center justify-between sm:flex">
          <div>
            <SuraasaPlusLogo color="light" height={35} width={200} />
            <Typography className="mt-1 text-surface-50">
              You&apos;ve already consumed free masterclass credit.{" "}
              {/* <span className="text-strong text-onSurface-300">
              Resets on 21 Aug
            </span> */}
            </Typography>
          </div>
          <Lock className="size-[60px] text-surface-100" strokeWidth={1.5} />
        </div>
        <div className="flex h-full flex-col items-center justify-center">
          <div className="flex max-w-[90%] flex-col items-center gap-1">
            <Typography
              className="max-w-[550px] text-surface"
              variant="largeBody"
            >
              Subscribe to Suraasa Plus to watch more masterclasses.
            </Typography>
            <Button
              onClick={() => {
                initiateSuraasaPlusPurchaseFlow()
              }}
              className="mt-1 bg-surface-50"
              color={null}
            >
              <Typography className="text-onSurface-900" variant="strong">
                Try Suraasa Plus
              </Typography>
            </Button>
          </div>
        </div>
      </div>

      <img
        alt="thumbnail"
        className="w-full rounded-lg"
        src={thumbnail}
        onError={e => (e.currentTarget.src = DEFAULT_MASTERCLASS_IMAGE)}
      />
    </div>
  )
}
export default TrySuraasaPlusScreen
